import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import { ItemProvider } from '../../providers/item';
import { SetupProvider } from '../../providers/setup';

@Component({
    selector: 'page-item',
    templateUrl: './item.html',
    styleUrls: ['./item.scss'],
		encapsulation: ViewEncapsulation.None
})
export class ItemPage {
	public item: any;
	public types: any;

	constructor (
		protected itemProv: ItemProvider,
		protected setupProv: SetupProvider,
  	private route: ActivatedRoute,
  	private router: Router,
  	private activeModal: NgbActiveModal,
	) {
	}

	ngOnInit() {

		this.setupProv.get('dish', 'types').subscribe(data => { this.types = data });
/*
	  this.route.paramMap
			.switchMap((params: ParamMap) => this.itemProv.get(params.get('uid'), params.get('iid')))
			.subscribe((val) => {
				this.item = val;
			});
*/
	}

	customIds(uid, iid) {
		this.itemProv.get(uid, iid).subscribe((val) => {
			this.item = val;
		});
	}
}



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/item/item.ts